import { p as public_env } from "./shared-server.js";
const HOUR_IN_MS = 36e5;
const DAY_IN_MS = 864e5;
const WEEK_IN_MS = 6048e5;
const MONTH_IN_MS = 2592e6;
const YEAR_IN_MS = 31536e6;
var TTL_STEPS = /* @__PURE__ */ ((TTL_STEPS2) => {
  TTL_STEPS2[TTL_STEPS2["HOUR"] = 0] = "HOUR";
  TTL_STEPS2[TTL_STEPS2["DAY"] = 1] = "DAY";
  TTL_STEPS2[TTL_STEPS2["WEEK"] = 2] = "WEEK";
  TTL_STEPS2[TTL_STEPS2["MONTH"] = 3] = "MONTH";
  TTL_STEPS2[TTL_STEPS2["YEAR"] = 4] = "YEAR";
  return TTL_STEPS2;
})(TTL_STEPS || {});
var THEME = /* @__PURE__ */ ((THEME2) => {
  THEME2[THEME2["DARK"] = 0] = "DARK";
  THEME2[THEME2["LIGHT"] = 1] = "LIGHT";
  return THEME2;
})(THEME || {});
const toTTLSTEP = (step, defaultValue) => {
  if (typeof step !== "string") {
    return defaultValue;
  }
  if (step.trim().length === 0 || step === "EVER") {
    return void 0;
  }
  const upperStep = step.toUpperCase();
  if (upperStep in TTL_STEPS) {
    return TTL_STEPS[upperStep];
  }
  throw new Error("Invalid TTL step");
};
const SHORTEN_LENGTH = Number(public_env.PUBLIC_ID_LENGTH ?? 5);
const MAX_TTL_USER = toTTLSTEP(public_env.PUBLIC_TTL_USER);
const MAX_TTL_TEMP = toTTLSTEP(public_env.PUBLIC_TTL_TEMP);
export {
  DAY_IN_MS as D,
  HOUR_IN_MS as H,
  MONTH_IN_MS as M,
  SHORTEN_LENGTH as S,
  THEME as T,
  WEEK_IN_MS as W,
  YEAR_IN_MS as Y,
  MAX_TTL_TEMP as a,
  MAX_TTL_USER as b
};
